import { icons } from "lucide-react";
import React from "react";

export default function Icon({ name, color = "#6b7280", size = 16 }) {
  const LucideIcon = icons[name];

  if (!LucideIcon) {
    if (process.env.NODE_ENV !== "production") {
      console.warn(
        `Icon not found in lucide-react: "${name}". Using fallback.`
      );
    }
    const Fallback = icons["CircleAlert"] || icons["Circle"] || icons["Square"];
    return <Fallback size={size} />;
  }

  return <LucideIcon size={size} />;
}
